// extracted by mini-css-extract-plugin
module.exports = {"container":"EventsPeriodChart_container__3P26u"};